import { useState } from "react";
import { AiOutlineClose, AiOutlinePlus } from "react-icons/ai";
import CreateGame from "./CreateGame";
import TableComponent from "./Table";
import { useDispatch, useSelector } from "react-redux";

const Games = () => {
 const dispatch = useDispatch();
  // Drawer state
  const [open, setOpen] = useState(false);
  const onClose = () => {
    setOpen(false);
  };
  // filter
  const [isFilter, setFilter] = useState(false);
  const filterToggle = () => {
    setFilter((prev) => !prev);
  };

  return (
    <div className='px-4'>
      <div className='bg-white dark:bg-DTableBg flex flex-row justify-between items-center gap-3 filter-wrapper border-radius-top table-top-padding'>
        <div className="flex items-center">
					<h2 className='text-xl md:text-2xl font-semibold'>Game Rooms List</h2>
				</div>
        <div className="flex flex-row sm:items-center gap-[12px]">
          {/*<div className='flex hidden md:flex sm:justify-end sm:items-center gap-5'>
            <button
              onClick={filterToggle}
              className={`hidden md:block ${isFilter ? "btn-secondary rounded-[1.25rem]" : "btn-secondary"
                }  px-5 py-2 rounded cursor-pointer rounded-[1.25rem]`}
              type='submit'>
              {isFilter ? (
                <span className='flex justify-center items-center gap-2'>
                  <AiOutlineClose /> Close
                </span>
              ) : (
                <span className=''>Filter</span>
              )}
            </button>
             {!isFilter ? (
              <CrmSearch paginatedThunk={loadAllTaskPaginated} />
            ) : (
              <div className='flex text-md'>
              </div>
            )} 
          </div>*/}
          <div className='flex justify-start md:justify-end'>
            <button
              onClick={() => setOpen(true)}
              className='py-2 px-2 lg:px-6 btn-primary text-[10px] md:text-[14px] text-white rounded cursor-pointer flex items-center gap-2'
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="plus-icon">
									<path stroke="white" fill-rule="evenodd" d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd" />
								</svg>
                <span className="text-white text-[10px] md:text-[14px] font-semibold">
                  Add Game Room
                </span>
            </button>
          </div>
        </div>
      </div>
      <TableComponent />
      <CreateGame onClose={onClose} open={open} />
    </div>
  );
};
export default Games;
